/* KIAA / R.K Handmade — homepage behaviour, ported from home.html
   All modules are defensive: each no-ops if its section isn't on the page. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Every init below runs through this guard, so a double include, a re-boot, or a
     theme-editor section reload can never attach two sets of dots/listeners. */
  function once(el, key) {
    if (!el) return false;
    var flag = 'kiaaInit' + key;
    if (el.dataset[flag] === '1') return false;
    el.dataset[flag] = '1';
    return true;
  }

  /* ── KIAA line-item properties ─────────────────────────────────────────
     Stamp the making rate and weight onto the cart line as line-item
     properties so they travel to checkout AND, most importantly, show under
     each item on the admin ORDER page (the size/length already shows there as
     the variant, so it isn't duplicated here). weight + labour are numbers
     (grams, ₹/g); size is the chosen length label ('18Inch' / 'Custom') or ''. */
  function kiaaNum(n) {
    n = Math.round(parseFloat(n) * 100) / 100;
    if (isNaN(n)) return '';
    return n % 1 === 0 ? String(Math.round(n)) : String(n);
  }
  function kiaaLineProps(weight, labour, size) {
    var props = {};
    var l = parseFloat(labour);
    var w = parseFloat(weight);
    var isCustom = size && String(size).toLowerCase().indexOf('custom') === 0;
    if (l > 0) props['Making charge'] = '₹' + kiaaNum(l) + '/g';
    // a Custom length has no known weight, so don't stamp a wrong one on it
    if (w > 0 && !isCustom) props['Weight'] = 'Approx. ' + kiaaNum(w) + 'g';
    // the chosen length/size, so it also shows in the order's property line
    // (Custom carries its own "Length (custom)" line, so skip the generic one)
    if (size && !isCustom && String(size).toLowerCase() !== 'default title') props['Length'] = size;
    return Object.keys(props).length ? props : null;
  }

  /* ── banner slider ─────────────────────────────────────────────────── */
  function initSlider(slider) {
    if (!once(slider, 'Slider')) return;
    var slides = slider.querySelector('[data-kiaa-slides]');
    var dotsBox = slider.querySelector('[data-kiaa-dots]');
    if (!slides || !dotsBox) return;

    dotsBox.innerHTML = ''; // belt and braces: never append onto an existing set
    var total = slides.children.length;
    if (total < 1) return;
    var i = 0;
    var timer = null;
    var speed = parseInt(slider.getAttribute('data-speed'), 10) || 5500;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';

    function go(n) {
      i = (n + total) % total;
      slides.style.transform = 'translateX(' + -i * 100 + '%)';
      for (var k = 0; k < dotsBox.children.length; k++) {
        dotsBox.children[k].className = k === i ? 'on' : '';
      }
    }
    function next() {
      go(i + 1);
    }
    function start() {
      if (!reduce && autoplay && total > 1) timer = setInterval(next, speed);
    }
    function stop() {
      clearInterval(timer);
    }
    function rest() {
      stop();
      start();
    }

    if (total > 1) {
      for (var d = 0; d < total; d++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to banner ' + (d + 1));
        b.addEventListener(
          'click',
          (function (n) {
            return function () {
              go(n);
              rest();
            };
          })(d)
        );
        dotsBox.appendChild(b);
      }
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);

      var x0 = null;
      slider.addEventListener(
        'touchstart',
        function (e) {
          x0 = e.touches[0].clientX;
        },
        { passive: true }
      );
      slider.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) {
          dx < 0 ? next() : go(i - 1);
          rest();
        }
        x0 = null;
      });
    }

    go(0);
    start();
  }

  /* ── horizontal rail + arrow buttons ───────────────────────────────── */
  function initRail(wrap) {
    if (!once(wrap, 'Rail')) return;
    var rail = wrap.querySelector('[data-kiaa-rail]');
    if (!rail) return;
    var prev = wrap.querySelector('[data-dir="prev"]');
    var next = wrap.querySelector('[data-dir="next"]');
    var fixedStep = parseInt(rail.getAttribute('data-step'), 10) || 0;
    var step = function () {
      return fixedStep || rail.clientWidth * 0.8;
    };

    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    var railNav = wrap.querySelector('.rail-nav');
    function state() {
      var max = rail.scrollWidth - rail.clientWidth;
      var scrollable = max > 2; // is there anything to scroll at all?
      // hide the whole arrow group when the row fits with no overflow
      if (railNav) railNav.style.display = scrollable ? '' : 'none';
      // hide each arrow when you can't scroll that direction
      if (prev) prev.style.display = scrollable && rail.scrollLeft > 2 ? '' : 'none';
      if (next) next.style.display = scrollable && rail.scrollLeft < max - 2 ? '' : 'none';
    }
    rail.addEventListener('scroll', state);
    window.addEventListener('resize', state);
    // images load lazily, so scrollWidth isn't final at init — recompute after load
    window.addEventListener('load', state);
    setTimeout(state, 400);
    state();
  }

  /* ── product grid filter chips ─────────────────────────────────────── */
  function initFilters(section) {
    if (!once(section, 'Filters')) return;
    var chips = section.querySelectorAll('[data-filter], [data-sort]');
    var grid = section.querySelector('[data-kiaa-grid]');
    var countEl = section.querySelector('[data-kiaa-count]');
    var emptyEl = section.querySelector('[data-kiaa-grid-empty]');
    if (!grid) return;
    // batch reveal works even when the filter toolbar is turned off
    initViewMore(section);
    if (!chips.length) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));

    function num(card, attr) {
      return parseFloat(card.getAttribute(attr)) || 0;
    }
    function reorder(mode) {
      var sorted = cards.slice().sort(function (a, b) {
        if (mode === 'newest') return num(b, 'data-published') - num(a, 'data-published');
        return num(a, 'data-order') - num(b, 'data-order');
      });
      sorted.forEach(function (c) {
        grid.appendChild(c);
      });
    }

    function matches(card, mode) {
      var w = parseFloat(card.getAttribute('data-weight')) || 0;
      var l = parseFloat(card.getAttribute('data-labour')) || 0;
      switch (mode) {
        case 'labour-under-100':
          return l > 0 && l < 100;
        case 'labour-100-180':
          return l >= 100 && l <= 180;
        case 'light':
          return w > 0 && w < 15;
        case 'heavy':
          return w >= 20;
        default:
          return true;
      }
    }

    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener('click', function () {
        Array.prototype.forEach.call(chips, function (c) {
          c.classList.remove('on');
        });
        chip.classList.add('on');

        var sort = chip.getAttribute('data-sort');
        // "Newest first" reorders and clears any filter; the rest filter in place
        var mode = sort ? 'all' : chip.getAttribute('data-filter');
        reorder(sort || 'default');

        var shown = 0;
        cards.forEach(function (card) {
          var ok = matches(card, mode);
          card.classList.toggle('is-hidden', !ok);
          if (ok) shown++;
        });
        if (countEl) countEl.textContent = shown;
        // when a chip matches nothing, hide the grid and show a "no designs" note
        if (emptyEl) emptyEl.hidden = shown !== 0;
        grid.style.display = shown === 0 ? 'none' : '';
        // let View more re-batch over the new matching set (first batch again)
        grid.dispatchEvent(new CustomEvent('kiaa:refilter'));
      });
    });
  }

  /* ── shoppable reels: inline autoplay ──────────────────────────────────
     Clips autoplay muted and loop, but only while they are on screen — six
     simultaneous downloads would be brutal on a phone connection. Sound is
     opt-in per clip via the speaker button, and only one clip is ever audible. */
  function initReelVideos(section) {
    if (!once(section, 'Clips')) return;
    var clips = section.querySelectorAll('[data-kiaa-clip]');
    if (!clips.length) return;

    function play(video) {
      if (reduce) return; // honour prefers-reduced-motion: leave the poster up
      var p = video.play();
      if (p && p.catch) p.catch(function () {}); // autoplay refusal is not an error
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              play(e.target);
            } else {
              e.target.pause();
              // a clip scrolled away should not keep talking
              if (!e.target.muted) setMuted(e.target, true);
            }
          });
        },
        // a low threshold so a clip that's only partly on screen (e.g. the first
        // ones on a shorter laptop screen) still autoplays instead of sitting still
        { threshold: 0.15 }
      );
      Array.prototype.forEach.call(clips, function (v) {
        io.observe(v);
      });
    } else {
      Array.prototype.forEach.call(clips, play);
    }

    function setMuted(video, muted) {
      video.muted = muted;
      var btn = video.parentNode.querySelector('[data-kiaa-mute]');
      if (!btn) return;
      btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      btn.setAttribute('title', muted ? 'Muted — tap for sound' : 'Sound on');
      btn.classList.toggle('is-on', !muted);
      var path = btn.querySelector('path');
      if (path) path.setAttribute('d', muted ? ICON_MUTED : ICON_LOUD);
    }

    Array.prototype.forEach.call(section.querySelectorAll('[data-kiaa-mute]'), function (btn) {
      btn.addEventListener('click', function (e) {
        // the button sits inside the product link, so don't navigate
        e.preventDefault();
        e.stopPropagation();
        var video = btn.parentNode.querySelector('[data-kiaa-clip]');
        if (!video) return;
        var turningOn = video.muted;
        if (turningOn) {
          // only one clip may be audible at a time
          Array.prototype.forEach.call(clips, function (other) {
            if (other !== video && !other.muted) setMuted(other, true);
          });
        }
        setMuted(video, !turningOn);
        if (turningOn) play(video);
      });
    });
  }

  var ICON_MUTED =
    'M4 9v6h4l5 4V5L8 9H4Zm12.5 3 2.6-2.6-1.1-1.1L15.4 11l-2.6-2.7-1.1 1.1L14.3 12l-2.6 2.6 1.1 1.1 2.6-2.6 2.6 2.6 1.1-1.1L16.5 12Z';
  var ICON_LOUD =
    'M4 9v6h4l5 4V5L8 9H4Zm11.5-.9v7.8a4.2 4.2 0 0 0 0-7.8Zm0-3.3v1.7a6.5 6.5 0 0 1 0 12.8V22a8.2 8.2 0 0 0 0-17.2Z';

  /* ── shoppable reels: add to cart ──────────────────────────────────── */
  function initReelAdd(section) {
    if (!once(section, 'Reels')) return;
    var buttons = section.querySelectorAll('[data-kiaa-add]');
    if (!buttons.length) return;

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-kiaa-add');
        if (!id) return;
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        kiaaCartAdd({ id: Number(id), quantity: 1 }, function () {
          btn.classList.add('done');
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.classList.remove('done');
            btn.textContent = original;
            btn.disabled = false;
          }, 1600);
        }, function () {
          btn.textContent = 'Try again';
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1600);
        });
      });
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      // let Dawn re-render its contents first
      if (typeof drawer.onCartDrawerAdd === 'function') drawer.onCartDrawerAdd();
      drawer.open();
      return;
    }
    window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
  }

  // A little "fly to the cart" flourish: clone the card's product photo and animate
  // it into the header cart icon. Resolves when it lands (or immediately when there's
  // nothing to animate / reduced motion is on), so the caller can then open the drawer.
  function flyToCart(btn) {
    return new Promise(function (resolve) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var card = btn.closest('.card');
      var img = card && card.querySelector('.c-img img');
      var target = document.querySelector('[data-kiaa-cart-target]') || document.querySelector('#cart-icon-bubble');
      if (reduce || !img || !target) { resolve(); return; }

      var imgRect = img.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      if (!imgRect.width || !targetRect.width) { resolve(); return; }

      var size = Math.min(imgRect.width, imgRect.height, 150);
      var startX = imgRect.left + imgRect.width / 2 - size / 2;
      var startY = imgRect.top + imgRect.height / 2 - size / 2;
      var endX = targetRect.left + targetRect.width / 2 - size / 2;
      var endY = targetRect.top + targetRect.height / 2 - size / 2;

      var clone = document.createElement('img');
      clone.src = img.currentSrc || img.src;
      clone.className = 'kiaa-fly-clone';
      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.left = '0px';
      clone.style.top = '0px';
      clone.style.opacity = '0.96';
      clone.style.transform = 'translate(' + startX + 'px,' + startY + 'px) scale(1)';
      clone.style.transition = 'transform 0.62s cubic-bezier(.5,-0.28,.35,1), opacity 0.62s ease';
      document.body.appendChild(clone);

      // commit the start frame, then animate to the cart on the next frame
      clone.getBoundingClientRect();
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + endX + 'px,' + endY + 'px) scale(0.12)';
        clone.style.opacity = '0.35';
      });

      var settled = false;
      function finish() {
        if (settled) return;
        settled = true;
        if (clone.parentNode) clone.parentNode.removeChild(clone);
        resolve();
      }
      clone.addEventListener('transitionend', finish);
      setTimeout(finish, 760); // fallback if transitionend never fires
    });
  }

  // pulse the header cart button (called the moment a flying item lands)
  function bumpCart() {
    var b = document.querySelector('#cart-icon-bubble');
    if (!b) return;
    b.classList.remove('kiaa-cart-bump');
    void b.offsetWidth; // restart the animation
    b.classList.add('kiaa-cart-bump');
    setTimeout(function () { b.classList.remove('kiaa-cart-bump'); }, 500);
  }

  // Shared cart-add: posts one line to /cart/add.js, swaps in the freshly rendered
  // cart-drawer and opens it — the same reliable path the reels and product page use.
  // Never touches the header cart-icon section (that would flip the KIAA icon colour);
  // the badge count is refreshed on its own.
  // With cart_type = notification, ask for the popup's sections instead and let
  // Dawn's <cart-notification> render + open it. Its cart-icon-bubble section is
  // the KIAA one, so the header icon stays as designed.
  function kiaaCartAdd(item, onOk, onErr) {
    var drawer = document.querySelector('cart-drawer');
    var notify = !drawer && document.querySelector('cart-notification');
    var body = { items: [item] };
    if (drawer) {
      body.sections = ['cart-drawer'];
      body.sections_url = window.location.pathname;
    } else if (notify) {
      body.sections = notify.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      notify.setActiveElement(document.activeElement);
    }
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          // e.g. "Only 10 items were added to your cart due to availability." —
          // part of the quantity may still have gone in, so refresh the badge
          refreshCartCount();
          if (onErr) onErr(res.data && (res.data.description || res.data.message));
          return;
        }
        var html = res.data.sections && res.data.sections['cart-drawer'];
        if (drawer && html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
          var current = drawer.querySelector('#CartDrawer');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') drawer.open();
        } else if (notify && res.data.sections && res.data.items && res.data.items[0]) {
          notify.renderContents({ key: res.data.items[0].key, sections: res.data.sections });
        } else {
          openCartDrawer();
        }
        refreshCartCount();
        if (onOk) onOk();
      })
      .catch(function () { if (onErr) onErr(); });
  }

  // small helper: flash a button's <span> label, then restore it
  function flashLabel(btn, msg) {
    var label = btn.querySelector('span') || btn;
    var orig = btn.__kiaaOrig != null ? btn.__kiaaOrig : label.textContent;
    btn.__kiaaOrig = orig;
    btn.disabled = true;
    label.textContent = '…';
    return function (done) {
      label.textContent = done || msg || '✓';
      setTimeout(function () { label.textContent = orig; btn.disabled = false; }, 1400);
    };
  }

  // Simple add-to-order button on cards WITHOUT length options: adds the design's
  // one variant, quantity 1, straight to the drawer. (No popup.)
  function initCardAdds(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('[data-kiaa-card-add]');
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.__kiaaCardAdd) return;
      btn.__kiaaCardAdd = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = Number(btn.getAttribute('data-kiaa-card-add'));
        if (!id) return;
        var card = btn.closest('.card');
        var item = { id: id, quantity: 1 };
        if (card) {
          var p = kiaaLineProps(card.getAttribute('data-weight'), card.getAttribute('data-labour'), '');
          if (p) item.properties = p;
        }
        var done = flashLabel(btn);
        kiaaCartAdd(item, function () { done('✓'); }, function () { done('Retry'); });
      });
    });
  }

  // Length picker on cards WITH a single option (18Inch / Custom): two variant
  // buttons + a quantity stepper. First value selected by default; picking Custom
  // raises the minimum quantity to 25. The header "Add" button adds the selected
  // variant × quantity to the drawer. Replaces the old quick-view popup.
  // Card buy area (every product card): optional length buttons, a quantity
  // stepper and an Add button. Each length button carries its own weight, making
  // rate, stock limit and price, so switching length updates the whole card.
  // Custom lengths have a 25-piece minimum.
  function initCardBuy(scope) {
    var root = scope || document;
    var widgets = root.querySelectorAll('[data-kiaa-cardbuy]');
    Array.prototype.forEach.call(widgets, function (w) {
      if (w.__kiaaBuy) return;
      w.__kiaaBuy = true;
      var vars = w.querySelectorAll('[data-var-id]');
      var defaultVar = w.getAttribute('data-default-var');
      if (!vars.length && !defaultVar) return;
      var card = w.closest('.card');
      var qInput = w.querySelector('[data-qinput]');
      var qNote = w.querySelector('[data-qnote]');
      var qMinus = w.querySelector('[data-qminus]');
      var qPlus = w.querySelector('[data-qplus]');
      var addBtn = w.querySelector('[data-kiaa-cardbuy-add]');
      var addLabel = addBtn ? addBtn.querySelector('span') : null;
      var actions = w.querySelector('.c-actions');
      var wtEl = card ? card.querySelector('[data-card-wt]') : null;
      var stockEl = card ? card.querySelector('[data-card-stock]') : null;
      var customWrap = w.querySelector('[data-card-custom]');
      var inchesInput = w.querySelector('[data-card-inches]');
      var wtDefault = wtEl ? wtEl.textContent : '';
      var selected = null;
      var noteTimer = null;

      function attr(name) {
        return selected ? selected.getAttribute('data-var-' + name) : (name === 'max' ? w.getAttribute('data-default-max') : null);
      }
      function currentId() { return Number(selected ? selected.getAttribute('data-var-id') : defaultVar); }
      function isCustom() { return attr('custom') === 'true'; }
      function soldOut() { return selected ? selected.hasAttribute('data-var-soldout') : w.hasAttribute('data-default-soldout'); }
      function minQty() { return isCustom() ? 25 : 1; }
      // stock cap, only for variants that track stock and stop selling at zero
      function maxQty() {
        var m = attr('max');
        return m === null || m === '' ? Infinity : Math.max(0, parseInt(m, 10) || 0);
      }
      function setNote(msg, temporary) {
        if (!qNote) return;
        clearTimeout(noteTimer);
        qNote.textContent = msg || '';
        if (temporary) noteTimer = setTimeout(baseNote, 4000);
      }
      function baseNote() {
        var max = maxQty();
        if (max > 0 && max < minQty()) setNote('Only ' + max + ' in stock, Custom needs 25');
        else if (isCustom()) setNote('Min 25 pcs for Custom');
        else if (max !== Infinity && max > 0 && max < 50) setNote('Only ' + max + ' in stock');
        else setNote('');
      }
      function clampQty() {
        if (!qInput) return 1;
        var min = minQty();
        var max = maxQty();
        var cur = parseInt(qInput.value, 10);
        if (isNaN(cur) || cur < min) cur = min;
        if (cur > max && max >= min) {
          cur = max;
          setNote('Only ' + max + ' in stock', true);
        }
        qInput.value = cur;
        return cur;
      }
      function syncAddBtn() {
        if (!addBtn) return;
        // "Sold out" only when there is truly nothing; short of the minimum just disables
        var none = soldOut() || maxQty() === 0;
        var off = none || maxQty() < minQty();
        addBtn.disabled = off;
        if (addLabel) addLabel.textContent = none ? 'Sold out' : 'Add';
        addBtn.__kiaaOrig = addLabel ? addLabel.textContent : null;
        // nothing can be ordered, so lock the quantity (and custom length) with it
        [qInput, qMinus, qPlus, inchesInput].forEach(function (el) { if (el) el.disabled = off; });
        if (actions) actions.classList.toggle('is-off', off);
        // the photo badge follows the picked variant: maroon "Out Of Stock" when it is sold out
        if (stockEl && selected) {
          stockEl.classList.toggle('in', !none);
          stockEl.classList.toggle('out', none);
          stockEl.lastChild.textContent = none ? 'Out Of Stock' : 'In Stock';
        }
      }
      function pick(b) {
        if (selected) { selected.classList.remove('on'); selected.setAttribute('aria-pressed', 'false'); }
        selected = b;
        b.classList.add('on');
        b.setAttribute('aria-pressed', 'true');
        // show this length's price block
        if (card) {
          Array.prototype.forEach.call(w.querySelectorAll('[data-var-price]'), function (el) {
            el.hidden = el.getAttribute('data-var-price') !== b.getAttribute('data-var-id');
          });
        }
        // and its weight on the photo badge (Custom has no fixed weight)
        if (wtEl) {
          var vw = b.getAttribute('data-var-w');
          wtEl.textContent = vw && !isCustom() ? kiaaNum(parseFloat(vw)) : wtDefault;
        }
        if (qInput) qInput.value = minQty();
        if (customWrap) {
          customWrap.hidden = !isCustom();
          if (inchesInput) inchesInput.classList.remove('err');
        }
        clampQty();
        syncAddBtn();
        baseNote();
      }
      function stop(e) { e.preventDefault(); e.stopPropagation(); }

      Array.prototype.forEach.call(vars, function (b) {
        b.addEventListener('click', function (e) { stop(e); pick(b); });
      });
      // the card is one big link: a tap anywhere on the buy row must not open it
      if (actions) actions.addEventListener('click', stop);
      if (customWrap) customWrap.addEventListener('click', function (e) {
        // keep the tap on the card (no navigation) but let the input take focus
        e.preventDefault();
        e.stopPropagation();
        if (inchesInput && e.target !== inchesInput) inchesInput.focus();
      });
      if (inchesInput) {
        inchesInput.addEventListener('input', function () {
          var clean = inchesInput.value.replace(/\D/g, '').slice(0, 3);
          if (clean !== inchesInput.value) inchesInput.value = clean;
          if (clean) { inchesInput.classList.remove('err'); baseNote(); }
        });
        inchesInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); if (addBtn) addBtn.click(); }
        });
      }
      if (qMinus) qMinus.addEventListener('click', function (e) {
        stop(e);
        if (addBtn && addBtn.disabled) return;
        var cur = parseInt(qInput.value, 10) || minQty();
        qInput.value = Math.max(minQty(), cur - 1);
        clampQty();
      });
      if (qPlus) qPlus.addEventListener('click', function (e) {
        stop(e);
        if (addBtn && addBtn.disabled) return;
        var cur = parseInt(qInput.value, 10) || minQty();
        qInput.value = cur + 1;
        clampQty();
      });
      if (qInput) {
        qInput.addEventListener('click', stop);
        qInput.addEventListener('focus', function () { qInput.select(); });
        qInput.addEventListener('input', function () { qInput.value = qInput.value.replace(/\D/g, ''); });
        qInput.addEventListener('change', clampQty);
        qInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); clampQty(); if (addBtn) addBtn.click(); }
        });
      }
      if (addBtn) addBtn.addEventListener('click', function (e) {
        stop(e);
        var id = currentId();
        if (!id || soldOut()) return;
        var qty = clampQty();
        var item = { id: id, quantity: qty };
        // Custom needs the length, same as the product page
        var inches = '';
        if (isCustom() && inchesInput) {
          inches = inchesInput.value.replace(/\D/g, '');
          if (!inches) {
            inchesInput.classList.add('err');
            inchesInput.focus();
            setNote('Please enter the length in inches');
            return;
          }
        }
        var p = selected
          ? kiaaLineProps(selected.getAttribute('data-var-w'), selected.getAttribute('data-var-l'), isCustom() ? 'custom' : selected.textContent.trim())
          : kiaaLineProps(card && card.getAttribute('data-weight'), card && card.getAttribute('data-labour'), '');
        if (inches) {
          // same order-line wording as the product page: "Length (custom): 22 inch"
          var withLen = { 'Length (custom)': inches + ' inch' };
          for (var pk in p) { withLen[pk] = p[pk]; }
          p = withLen;
        }
        if (p) item.properties = p;
        var done = flashLabel(addBtn);
        kiaaCartAdd(item, function () {
          done('✓');
          baseNote();
        }, function (msg) {
          done('!');
          setNote(msg || 'Could not add. Please try again.', true);
        });
      });

      // start on the length that is marked selected (first available), else the first
      var start = w.querySelector('[data-var-id].on') || vars[0];
      if (start) pick(start);
      else { clampQty(); syncAddBtn(); baseNote(); }
    });
  }

  /* ── quick-view popup ──────────────────────────────────────────────────
     Fetches the product page, lifts out its [data-kiaa-product] block (which
     carries the whole variant picker + custom-length + price panel + add form)
     and drops it into a modal, then boots it so every bit of product JS runs
     there — including the corrected labour×weight pricing. */
  var qvEl = null;
  function ensureQuickView() {
    if (qvEl) return qvEl;
    qvEl = document.createElement('div');
    qvEl.className = 'kiaa kiaa-scope kiaa-qv';
    qvEl.setAttribute('data-kiaa-quickview', '');
    qvEl.hidden = true;
    qvEl.innerHTML =
      '<div class="kiaa-qv__overlay" data-kiaa-qv-close></div>' +
      '<div class="kiaa-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
        '<button class="kiaa-qv__close" type="button" data-kiaa-qv-close aria-label="Close">&times;</button>' +
        '<div class="kiaa-qv__body" data-kiaa-qv-body></div>' +
      '</div>';
    document.body.appendChild(qvEl);
    Array.prototype.forEach.call(qvEl.querySelectorAll('[data-kiaa-qv-close]'), function (c) {
      c.addEventListener('click', closeQuickView);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && qvEl && !qvEl.hidden) closeQuickView();
    });
    return qvEl;
  }
  function closeQuickView() {
    if (!qvEl) return;
    qvEl.hidden = true;
    document.body.classList.remove('kiaa-qv-open');
  }
  function openQuickView(url) {
    var el = ensureQuickView();
    var body = el.querySelector('[data-kiaa-qv-body]');
    body.innerHTML = '<div class="kiaa-qv__loading">Loading…</div>';
    el.hidden = false;
    document.body.classList.add('kiaa-qv-open');
    var clean = url.split('#')[0];
    fetch(clean)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var prod = doc.querySelector('[data-kiaa-product]');
        // not a KIAA product template (e.g. a plain product): just go to the page
        if (!prod) { window.location.href = clean; return; }
        // strip the bits that don't belong in a compact popup
        Array.prototype.forEach.call(
          prod.querySelectorAll('.crumb, .kiaa-strip-wrap, .kiaa-sticky-buy, .pdp-share-float'),
          function (n) { if (n.parentNode) n.parentNode.removeChild(n); }
        );
        body.innerHTML = '';
        body.appendChild(prod);
        var more = document.createElement('a');
        more.className = 'kiaa-qv__full';
        more.href = clean;
        more.innerHTML = 'View full details →';
        body.appendChild(more);
        boot(body);
        body.scrollTop = 0;
        el.querySelector('.kiaa-qv__panel').scrollTop = 0;
      })
      .catch(function () { window.location.href = clean; });
  }

  function refreshCartCount() {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-kiaa-cart-count]');
        // the badge is only in the markup when the cart already had items — if a
        // just-added item needs one, create it inside the header cart icon
        if (!badges.length && cart.item_count > 0) {
          var host = document.getElementById('cart-icon-bubble');
          if (host) {
            var span = document.createElement('span');
            span.className = 'badge';
            span.setAttribute('data-kiaa-cart-count', '');
            host.appendChild(span);
            badges = [span];
          }
        }
        Array.prototype.forEach.call(badges, function (b) {
          b.textContent = cart.item_count;
          b.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ── video modal ───────────────────────────────────────────────────── */
  function initVideoModal() {
    var scrimEl = document.getElementById('kiaaVidScrim');
    if (!once(scrimEl, 'Video')) return;
    var triggers = document.querySelectorAll('[data-video]');
    if (!triggers.length) return;

    var scrim = document.getElementById('kiaaVidScrim');
    if (!scrim) return;
    var closeBtn = scrim.querySelector('[data-vid-close]');
    var frame = scrim.querySelector('[data-vid-frame]');
    var titleEl = scrim.querySelector('[data-vid-title]');
    var metaEl = scrim.querySelector('[data-vid-meta]');
    var placeholder = frame ? frame.innerHTML : '';

    function open(el) {
      var t = el.getAttribute('data-video');
      var m = el.getAttribute('data-video-meta');
      var src = el.getAttribute('data-video-src');
      if (t && titleEl) titleEl.textContent = t;
      if (m && metaEl) metaEl.textContent = m;
      if (frame) {
        if (src) {
          if (/\.(mp4|webm|mov)(\?|$)/i.test(src)) {
            frame.innerHTML =
              '<video src="' + encodeURI(src) + '" controls autoplay playsinline></video>';
          } else {
            frame.innerHTML =
              '<iframe src="' +
              encodeURI(src) +
              '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Product video"></iframe>';
          }
        } else {
          frame.innerHTML = placeholder;
        }
      }
      scrim.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }
    function shut() {
      scrim.classList.remove('open');
      document.body.style.overflow = '';
      if (frame) frame.innerHTML = placeholder; // stops playback
    }

    if (closeBtn) closeBtn.addEventListener('click', shut);
    scrim.addEventListener('click', function (e) {
      if (e.target === scrim) shut();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && scrim.classList.contains('open')) shut();
    });

    Array.prototype.forEach.call(triggers, function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('.vmute')) return;
        e.preventDefault();
        open(el);
      });
    });

    // Mute buttons belong to inline clips and are wired in initReelVideos, which
    // toggles the actual audio. Nothing to do here.
  }

  /* ── category bar: scroll the active chip into view ────────────────── */
  function initCatbar() {
    var bar = document.querySelector('.kiaa-catbar-inner');
    if (!bar) return;
    var on = bar.querySelector('.cbtn.on');
    if (!on) return;
    function reveal() {
      var left = on.offsetLeft - bar.offsetLeft;
      var overflowsRight = left + on.offsetWidth > bar.scrollLeft + bar.clientWidth;
      var overflowsLeft = left < bar.scrollLeft;
      if (overflowsRight || overflowsLeft) bar.scrollLeft = Math.max(0, left - 16);
    }
    reveal();
    window.addEventListener('resize', reveal);
  }

  /* ── sticky offsets ────────────────────────────────────────────────────
     The category bar sits directly under the header. Its offset was hard-coded
     to 75px, which was wrong at every width where the header is a different
     height. Measure it instead and publish it as a custom property. */
  function initStickyOffsets() {
    var header = document.querySelector('.kiaa-header');
    if (!header) return;
    var raf = null;
    var catbar = document.querySelector('.kiaa-catbar');
    function measure() {
      var h = Math.round(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--kiaa-header-h', h + 'px');
      // header + category bar: how much an in-page anchor must clear, or the
      // section it jumps to lands underneath the sticky chrome
      var c = catbar ? Math.round(catbar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--kiaa-sticky-h', h + c + 'px');
    }
    function schedule() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(measure);
    }
    measure();
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(header);
    // fonts land after first paint and change the header height
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  /* ── mobile search toggle ──────────────────────────────────────────────
     The search field is hidden on narrow screens to keep the header one row;
     this reveals it as a full-width row under the header. */
  function initMobileSearch() {
    var btn = document.querySelector('[data-kiaa-search-toggle]');
    var panel = document.querySelector('[data-kiaa-search-panel]');
    if (!once(btn, 'Search') || !panel) return;

    btn.addEventListener('click', function () {
      var open = panel.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = panel.querySelector('input');
        if (input) input.focus();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('open')) {
        panel.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  }

  /* ── collection page ───────────────────────────────────────────────────
     Sorting and filtering navigate, so results stay correct across pages
     rather than only reordering the page you happen to be looking at. */
  function initCollection(root) {
    if (!once(root, 'Collection')) return;

    var toggle = root.querySelector('[data-kiaa-side-toggle]');
    var side = root.querySelector('#kiaaSide');
    if (toggle && side) {
      // Applying a making-charge or availability filter reloads the page, which would
      // otherwise collapse the panel. Remember the open/closed state so it stays put.
      var SIDE_KEY = 'kiaaFiltersOpen';
      var wasOpen = false;
      try { wasOpen = localStorage.getItem(SIDE_KEY) === '1'; } catch (e) {}
      if (wasOpen) {
        side.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
      }
      toggle.addEventListener('click', function () {
        var open = side.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        try { localStorage.setItem(SIDE_KEY, open ? '1' : '0'); } catch (e) {}
      });
    }

    function go(url) {
      window.location.href = url;
    }
    function paramsFromForm(form) {
      var p = new URLSearchParams();
      Array.prototype.forEach.call(form.elements, function (el) {
        // making-charge, weight, availability and design-line bands filter the page
        // in place — they never become URL params
        if (el.hasAttribute && (el.hasAttribute('data-kiaa-rate-band') || el.hasAttribute('data-kiaa-weight-band') || el.hasAttribute('data-kiaa-avail-band') || el.hasAttribute('data-kiaa-line-band'))) return;
        if (!el.name || el.disabled) return;
        if (el.type === 'checkbox') {
          if (el.checked) p.append(el.name, el.value);
        } else if (el.value !== '') {
          p.append(el.name, el.value);
        }
      });
      return p;
    }

    initClientFilters(root);
    initViewMore(root);

    var form = root.querySelector('[data-kiaa-filter-form]');
    var sort = root.querySelector('[data-kiaa-sort]');

    if (form) {
      form.addEventListener('change', function (e) {
        // in-place bands (making charge / weight / availability / design line) must not navigate
        var t = e.target;
        if (t && t.hasAttribute && (t.hasAttribute('data-kiaa-rate-band') || t.hasAttribute('data-kiaa-weight-band') || t.hasAttribute('data-kiaa-avail-band') || t.hasAttribute('data-kiaa-line-band'))) return;
        var p = paramsFromForm(form);
        if (sort && sort.value) p.set('sort_by', sort.value);
        go(window.location.pathname + '?' + p.toString());
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        form.dispatchEvent(new Event('change'));
      });
    }

    if (sort) {
      sort.addEventListener('change', function () {
        // the two weight options sort in place; Shopify can't sort by a metafield
        if (sort.value.indexOf('kiaa-weight') === 0) {
          sortByWeight(root, sort.value === 'kiaa-weight-desc');
          // the grid order changed, so re-run the batch reveal from the top
          var g = root.querySelector('.p-grid');
          if (g) g.dispatchEvent(new Event('kiaa:refilter'));
          return;
        }
        var p = form ? paramsFromForm(form) : new URLSearchParams(window.location.search);
        p.set('sort_by', sort.value);
        go(window.location.pathname + '?' + p.toString());
      });
    }
  }

  /* Reorder the grid by the weight on each card. Pieces without a weight sink to
     the bottom rather than sorting as zero. */
  function sortByWeight(root, desc) {
    var grid = root.querySelector('.p-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
    cards
      .sort(function (a, b) {
        var wa = parseFloat(a.getAttribute('data-weight'));
        var wb = parseFloat(b.getAttribute('data-weight'));
        if (isNaN(wa) && isNaN(wb)) return 0;
        if (isNaN(wa)) return 1;
        if (isNaN(wb)) return -1;
        return desc ? wb - wa : wa - wb;
      })
      .forEach(function (c) {
        grid.appendChild(c);
      });
  }

  /* ── client-side sidebar filters ────────────────────────────────────────
     Design line and weight have no native Shopify equivalent (line membership
     isn't a filterable field, and weight needs a metafield filter configured),
     so these narrow the designs already on the page and keep removable pills in
     sync. Price and availability stay server-side. Groups combine with AND,
     options inside a group with OR. */
  function initClientFilters(root) {
    var lineBoxes = root.querySelectorAll('[data-kiaa-line-band]');
    var weightBoxes = root.querySelectorAll('[data-kiaa-weight-band]');
    var rateBoxes = root.querySelectorAll('[data-kiaa-rate-band]');
    var availBoxes = root.querySelectorAll('[data-kiaa-avail-band]');
    if (!lineBoxes.length && !weightBoxes.length && !rateBoxes.length && !availBoxes.length) return;

    var grid = root.querySelector('.p-grid');
    var pills = root.querySelector('[data-kiaa-pills]');
    var countEl = root.querySelector('.bar .count');
    var empty = root.querySelector('[data-kiaa-client-empty]');
    var emptyText = root.querySelector('[data-kiaa-empty-text]');
    var clearBtn = root.querySelector('[data-kiaa-clear-client]');
    if (!grid) return;
    var countHtml = countEl ? countEl.innerHTML : null;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));

    function labelOf(box) {
      var nm = box.parentNode.querySelector('.nm');
      return nm ? nm.textContent.trim() : 'Filter';
    }
    function checked(list) {
      return Array.prototype.filter.call(list, function (b) {
        return b.checked;
      });
    }

    function apply() {
      var activeLines = checked(lineBoxes);
      var activeWeights = checked(weightBoxes);
      var activeRates = checked(rateBoxes);
      var activeAvail = checked(availBoxes);

      cards.forEach(function (card) {
        var ok = true;

        if (activeLines.length) {
          var mine = ' ' + (card.getAttribute('data-lines') || '') + ' ';
          ok = activeLines.some(function (b) {
            return mine.indexOf(' ' + b.getAttribute('data-line') + ' ') !== -1;
          });
        }

        if (ok && activeAvail.length) {
          // In stock / Out of stock — matches the card's data-available ("true"/"false")
          var av = card.getAttribute('data-available');
          ok = activeAvail.some(function (b) {
            return b.getAttribute('data-avail') === av;
          });
        }

        if (ok && activeRates.length) {
          // making charge / gram lives on the card as data-labour
          var rate = parseFloat(card.getAttribute('data-labour'));
          ok = !isNaN(rate) && activeRates.some(function (b) {
            var lo = parseFloat(b.getAttribute('data-rmin'));
            var hi = parseFloat(b.getAttribute('data-rmax'));
            // lower-inclusive, upper-exclusive — matches the ₹20 bands' counting
            return rate >= lo && rate < hi;
          });
        }

        if (ok && activeWeights.length) {
          var w = parseFloat(card.getAttribute('data-weight'));
          ok = !isNaN(w) && activeWeights.some(function (b) {
            var lo = parseFloat(b.getAttribute('data-wmin'));
            var hi = parseFloat(b.getAttribute('data-wmax'));
            // lower-exclusive so a 12 g piece lands in "12 – 18", not "under 12"
            return lo === 0 ? w <= hi : w > lo && w <= hi;
          });
        }

        card.classList.toggle('is-hidden', !ok);
      });

      var shown = cards.filter(function (c) {
        return !c.classList.contains('is-hidden');
      }).length;
      var anyActive =
        activeLines.length + activeWeights.length + activeRates.length + activeAvail.length;
      if (countEl) {
        countEl.innerHTML = anyActive
          ? 'Showing <b>' + shown + '</b> of <b>' + cards.length + '</b> designs on this page'
          : countHtml;
      }

      // an empty result needs to say so, not just leave a blank space
      if (empty) {
        var isEmpty = anyActive > 0 && shown === 0;
        empty.hidden = !isEmpty;
        if (grid) grid.style.display = isEmpty ? 'none' : '';
        if (isEmpty && emptyText) {
          var names = activeLines.concat(activeRates, activeWeights, activeAvail).map(labelOf);
          emptyText.textContent =
            names.length === 1
              ? 'No designs in ' + names[0]
              : 'No designs match ' + names.join(' + ');
        }
      }

      if (pills) {
        Array.prototype.forEach.call(pills.querySelectorAll('[data-client-pill]'), function (p) {
          p.remove();
        });
        activeLines.concat(activeRates, activeWeights, activeAvail).forEach(function (b) {
          var pill = document.createElement('span');
          pill.className = 'pill';
          pill.setAttribute('data-client-pill', '');
          pill.textContent = labelOf(b) + ' ';
          var x = document.createElement('a');
          x.href = '#';
          x.setAttribute('aria-label', 'Remove ' + labelOf(b) + ' filter');
          x.textContent = '×';
          x.addEventListener('click', function (e) {
            e.preventDefault();
            b.checked = false;
            apply();
          });
          pill.appendChild(x);
          pills.appendChild(pill);
        });
      }

      // the visible set changed — let "View more" re-count and reveal from the top
      grid.dispatchEvent(new Event('kiaa:refilter'));
    }

    Array.prototype.forEach.call(lineBoxes, function (b) {
      b.addEventListener('change', apply);
    });
    Array.prototype.forEach.call(rateBoxes, function (b) {
      b.addEventListener('change', apply);
    });
    Array.prototype.forEach.call(availBoxes, function (b) {
      b.addEventListener('change', apply);
    });
    Array.prototype.forEach.call(weightBoxes, function (b) {
      b.addEventListener('change', apply);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        Array.prototype.forEach.call(lineBoxes, function (b) {
          b.checked = false;
        });
        Array.prototype.forEach.call(rateBoxes, function (b) {
          b.checked = false;
        });
        Array.prototype.forEach.call(availBoxes, function (b) {
          b.checked = false;
        });
        Array.prototype.forEach.call(weightBoxes, function (b) {
          b.checked = false;
        });
        apply();
      });
    }
  }

  /* ── "View more" batch reveal ───────────────────────────────────────────
     Every design is in the DOM; this shows them a batch at a time instead of
     paginating — 8 per click on phones, 12 on wider screens. It reads the live
     grid each pass so it respects the client weight-sort and only ever counts
     designs the active filters haven't already hidden. */
  function initViewMore(root) {
    var grid = root.querySelector('.p-grid');
    var wrap = root.querySelector('[data-kiaa-view-more-wrap]');
    var btn = root.querySelector('[data-kiaa-view-more]');
    if (!grid || !wrap || !btn) return;

    function step() {
      var d = parseInt(grid.getAttribute('data-step-desktop'), 10) || 12;
      var m = parseInt(grid.getAttribute('data-step-mobile'), 10) || 8;
      return window.matchMedia('(min-width: 750px)').matches ? d : m;
    }

    var limit = step();

    function render() {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
      var shown = 0;
      var matching = 0;
      cards.forEach(function (card) {
        // a card the filters hid never counts toward the batch
        if (card.classList.contains('is-hidden')) {
          card.classList.remove('is-beyond');
          return;
        }
        matching++;
        if (shown < limit) {
          card.classList.remove('is-beyond');
          shown++;
        } else {
          card.classList.add('is-beyond');
        }
      });
      // nothing left to reveal → retire the button
      wrap.hidden = limit >= matching;
    }

    btn.addEventListener('click', function () {
      limit += step();
      render();
    });

    // filtering or the client sort changed the set: start again at the first batch
    grid.addEventListener('kiaa:refilter', function () {
      limit = step();
      render();
    });

    render();
  }

  /* ── product-card image carousel ───────────────────────────────────── */
  function initCardCarousels(root) {
    var boxes = root.querySelectorAll('.c-img.has-carousel');
    Array.prototype.forEach.call(boxes, function (box) {
      if (!once(box, 'Carousel')) return;
      var track = box.querySelector('.c-track');
      var dots = box.querySelectorAll('.c-dots i');
      if (!track || !dots.length) return;
      var total = track.children.length;
      var i = 0;

      function go(n) {
        i = (n + total) % total;
        track.style.transform = 'translateX(' + -i * 100 + '%)';
        Array.prototype.forEach.call(dots, function (d, k) {
          d.classList.toggle('on', k === i);
        });
      }

      // auto-advance: each next image slides in from the right. Pauses on hover
      // and while a finger is down, and honours prefers-reduced-motion.
      var timer = null;
      function stop() {
        clearInterval(timer);
        timer = null;
      }
      function start() {
        if (reduce || total < 2) return;
        stop();
        timer = setInterval(function () {
          go(i + 1);
        }, 3000);
      }
      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', start);

      Array.prototype.forEach.call(dots, function (d, k) {
        // the card is a link, so a dot must not navigate
        d.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          go(k);
          start(); // restart the clock so it doesn't jump right after a manual pick
        });
      });

      var x0 = null;
      box.addEventListener(
        'touchstart',
        function (e) {
          x0 = e.touches[0].clientX;
          stop();
        },
        { passive: true }
      );
      box.addEventListener('touchend', function (e) {
        if (x0 !== null) {
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 36) {
            e.preventDefault();
            go(i + (dx < 0 ? 1 : -1));
          }
        }
        x0 = null;
        start();
      });

      // desync the fleet so cards don't all flip on the same beat
      setTimeout(start, 300 + Math.round(i * 0) + (total > 1 ? (box.getBoundingClientRect().left % 1500) : 0));
    });
  }

  /* ── land on the right section when arriving with a #hash ──────────────
     Arriving at /#videos, the browser jumps before the lazy images above the
     target have loaded. They then reflow the page and the jump is lost — landing
     back at the top roughly two times in three. Re-apply it once things settle;
     scrollIntoView honours the scroll-margin that clears the sticky header. */
  function initHashScroll() {
    if (!window.location.hash || window.location.hash.length < 2) return;
    var target;
    try {
      target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    } catch (e) {
      return;
    }
    if (!target || !once(target, 'HashScroll')) return;

    function land() {
      target.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    land();
    // once more after load, by which time the images above have taken their space
    if (document.readyState === 'complete') {
      setTimeout(land, 80);
    } else {
      window.addEventListener('load', function () {
        setTimeout(land, 80);
      });
    }
  }

  /* ── boot ──────────────────────────────────────────────────────────── */
  /* ── product page: option selection, live making charge, gallery ──────────
     One handler for all four PDP layouts (simple / swatch / size+colour /
     size cards). It reads the per-variant JSON the section prints and keeps
     the price panel, gallery, spec rows, hidden cart id and sticky bar in
     sync with the selected options and quantity. Scoped to its own root so a
     second product section on a page can never touch this one's nodes. */
  // reveal one gallery media slide by id, pause any video left behind, and sync
  // the thumb "on" state. Used by thumb clicks and by variant image switches.
  function galShow(root, mediaId) {
    if (mediaId == null) return;
    var id = String(mediaId);
    var slides = root.querySelectorAll('[data-kiaa-slide]');
    Array.prototype.forEach.call(slides, function (s) {
      var on = s.getAttribute('data-media-id') === id;
      s.classList.toggle('on', on);
      if (!on) { var vid = s.querySelector('video'); if (vid) vid.pause(); }
    });
    var th = root.querySelector('[data-kiaa-thumbs]');
    if (th) Array.prototype.forEach.call(th.querySelectorAll('button'), function (b) {
      b.classList.toggle('on', b.getAttribute('data-media-id') === id);
    });
  }

  function initProduct(root) {
    if (!once(root, 'Product')) return;

    var dataEl = root.querySelector('[data-kiaa-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var qtyInput = root.querySelector('[data-kiaa-qty]');
    var customWrap = root.querySelector('[data-kiaa-custom-wrap]');
    var customInput = root.querySelector('[data-kiaa-custom-inches]');
    var CUSTOM_MOQ = 25;
    var qtyMin = 1;
    var wasCustom = false;
    // the "Custom" length tile: its option value starts with "custom"
    var isCustom = function () {
      return state.some(function (s) { return s && String(s).toLowerCase().indexOf('custom') === 0; });
    };
    var money = function (cents) {
      var r = cents / 100;
      var whole = Math.round(r) === r;
      return '₹' + (whole ? Math.round(r) : r.toFixed(2)).toLocaleString('en-IN');
    };
    var numTxt = function (n) { return (Math.round(n * 100) / 100).toString(); };
    var grams = function (n) { return numTxt(Math.round(n * 10) / 10) + 'g'; };
    var pcs = function (q) { return q + (q > 1 ? ' pcs' : ' pc'); };
    var setText = function (sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; };
    var hide = function (sel, yes) { var el = root.querySelector(sel); if (el) el.hidden = yes; };
    var qtyVal = function () { return Math.max(qtyMin, parseInt(qtyInput ? qtyInput.value : qtyMin, 10) || qtyMin); };

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-kiaa-opt]'));
    var state = [];
    var first = variants.filter(function (v) { return v.available; })[0] || variants[0];
    state[0] = first.o1; state[1] = first.o2; state[2] = first.o3;
    var posList = function () { return groups.map(function (g) { return parseInt(g.getAttribute('data-kiaa-opt'), 10) - 1; }); };

    function matchOn(v, positions) {
      for (var i = 0; i < positions.length; i++) {
        var p = positions[i], key = p === 0 ? 'o1' : p === 1 ? 'o2' : 'o3';
        if (state[p] != null && v[key] !== state[p]) return false;
      }
      return true;
    }
    function findVariant() {
      var pos = posList();
      if (!pos.length) return variants[0];
      var exact = variants.filter(function (v) { return matchOn(v, pos); });
      if (exact.length) return exact.filter(function (v) { return v.available; })[0] || exact[0];
      var byPrimary = variants.filter(function (v) { return matchOn(v, [pos[0]]); });
      return byPrimary[0] || variants[0];
    }
    var keyOf = function (p) { return p === 0 ? 'o1' : p === 1 ? 'o2' : 'o3'; };

    // After the user changes one option, snap the OTHER options to a real,
    // available variant that keeps the changed option — so picking "9/0 Single
    // Line" moves the colour to one that exists in that size, and the picker
    // only ever offers combinations that can actually be ordered.
    function reconcile(changedPos) {
      var avail = variants.filter(function (v) { return v.available && v[keyOf(changedPos)] === state[changedPos]; });
      if (!avail.length) avail = variants.filter(function (v) { return v[keyOf(changedPos)] === state[changedPos]; });
      if (!avail.length) return;
      var best = avail[0], bestScore = -1;
      avail.forEach(function (v) {
        var score = 0;
        posList().forEach(function (p) { if (p !== changedPos && v[keyOf(p)] === state[p]) score++; });
        if (score > bestScore) { bestScore = score; best = v; }
      });
      state[0] = best.o1; state[1] = best.o2; state[2] = best.o3;
    }

    // write everything the panel/gallery/specs show for one selected variant
    function paint(o) {
      var mkTotal = o.mkCents * o.q;
      var wTotal = o.w * o.q;
      setText('[data-kiaa-mk-total]', money(mkTotal));
      var calc;
      if (o.breakdown) calc = '₹' + numTxt(o.l) + '/g × ' + numTxt(o.w) + 'g × ' + pcs(o.q);
      else if (o.hasW && o.w > 0) calc = numTxt(o.w) + 'g × ' + pcs(o.q);
      else calc = pcs(o.q);
      setText('[data-kiaa-mk-calc]', calc);
      if (o.varTitle != null) setText('[data-kiaa-row-var]', o.varTitle);
      setText('[data-kiaa-row-qty]', pcs(o.q));

      // weight-dependent rows/tiles hide when this variant has no weight metafield
      hide('[data-kiaa-row-wt-wrap]', !o.hasW);
      hide('[data-kiaa-row-ag-wrap]', !o.hasW);
      hide('[data-kiaa-spec-wt-row]', !o.hasW);
      hide('[data-kiaa-ks-wt-tile]', !o.hasW);
      hide('[data-kiaa-spec-lb-row]', !o.hasL);
      hide('[data-kiaa-ks-lb-tile]', !o.hasL);
      if (o.hasW) {
        setText('[data-kiaa-row-wt]', grams(wTotal));
        setText('[data-kiaa-row-ag]', "today's rate × " + grams(wTotal));
        setText('[data-kiaa-gal-wt]', numTxt(o.w) + 'g');
        setText('[data-kiaa-spec-wt]', numTxt(o.w));
        setText('[data-kiaa-ks-wt]', numTxt(o.w) + 'g');
      }
      hide('[data-kiaa-gal-wt]', !o.hasW);
      if (o.hasL) {
        setText('[data-kiaa-spec-lb]', numTxt(o.l));
        setText('[data-kiaa-ks-lb]', '₹' + numTxt(o.l) + ' /g');
      }
      setText('[data-kiaa-row-tot]', o.hasW ? 'rate × ' + grams(wTotal) + ' + ' + money(mkTotal) : money(mkTotal));

      // keyspec wrapper hides when no tile is left visible
      var keyspec = root.querySelector('[data-kiaa-keyspec]');
      if (keyspec) {
        var anyVisible = Array.prototype.some.call(keyspec.querySelectorAll('.ks'), function (t) { return !t.hidden; });
        keyspec.hidden = !anyVisible;
      }

      // design code (may carry no value)
      var code = o.code || '';
      hide('[data-kiaa-code-wrap]', !code);
      hide('[data-kiaa-gal-code]', !code);
      hide('[data-kiaa-code-row]', !code);
      if (code) { setText('[data-kiaa-gal-code]', code); setText('[data-kiaa-code]', code); setText('[data-kiaa-spec-code]', code); }

      setText('[data-kiaa-spec-stock]', o.available ? 'Ready stock' : 'Made to order');
      setText('[data-kiaa-sticky-total]', money(mkTotal));
      setText('[data-kiaa-sticky-calc]', o.hasW ? '+ silver rate × ' + grams(wTotal) : 'silver at today’s rate');

      var idInput = root.querySelector('[data-kiaa-varid]');
      if (idInput) { if (o.varId != null) idInput.value = o.varId; idInput.disabled = !o.available; }
      var addBtn = root.querySelector('[data-kiaa-add]');
      if (addBtn) { addBtn.disabled = !o.available; setText('[data-kiaa-add-text]', o.available ? 'Add to order' : 'Not available'); }
      // Out of stock: quantity shows 0 and the − / + stepper is disabled (can't change).
      var minusBtn = root.querySelector('[data-kiaa-minus]');
      var plusBtn = root.querySelector('[data-kiaa-plus]');
      if (!o.available) {
        if (qtyInput) { qtyInput.value = 0; qtyInput.setAttribute('min', 0); qtyInput.disabled = true; }
        if (minusBtn) minusBtn.disabled = true;
        if (plusBtn) plusBtn.disabled = true;
        setText('[data-kiaa-row-qty]', '0 pc');
      } else {
        if (qtyInput) qtyInput.disabled = false;
        if (minusBtn) minusBtn.disabled = false;
        if (plusBtn) plusBtn.disabled = false;
      }
      setText('[data-kiaa-moq]', (o.available ? 'Ready stock' : 'Made to order, 10–12 days') +
        ' · no payment at checkout · final amount confirmed before you pay');
    }

    function render() {
      var custom = isCustom();
      qtyMin = custom ? CUSTOM_MOQ : 1;
      if (custom) {
        // Custom needs at least 25; bump up if below
        if (qtyInput && (parseInt(qtyInput.value, 10) || 1) < CUSTOM_MOQ) qtyInput.value = CUSTOM_MOQ;
      } else if (wasCustom && qtyInput) {
        // just switched from Custom back to a fixed size → reset the forced 25 to 1
        qtyInput.value = 1;
      }
      wasCustom = custom;
      var q = qtyVal();
      if (qtyInput) { qtyInput.value = q; qtyInput.setAttribute('min', qtyMin); }
      var v = findVariant();
      var pos = posList();
      var exact = groups.length ? variants.filter(function (x) { return matchOn(x, pos); }) : [v];
      var available = exact.some(function (x) { return x.available; }) && v.available;

      groups.forEach(function (g) {
        var p = parseInt(g.getAttribute('data-kiaa-opt'), 10) - 1;
        var picked = g.querySelector('[data-opt-picked]');
        if (picked) picked.textContent = state[p];
        Array.prototype.forEach.call(g.querySelectorAll('[data-opt-value]'), function (btn) {
          var val = btn.getAttribute('data-opt-value');
          btn.classList.toggle('on', val === state[p]);
          var probe = state.slice(); probe[p] = val;
          var ok = variants.some(function (x) {
            if (!x.available) return false;
            for (var i = 0; i < pos.length; i++) {
              var pp = pos[i], kk = pp === 0 ? 'o1' : pp === 1 ? 'o2' : 'o3';
              if (x[kk] !== probe[pp]) return false;
            }
            return true;
          });
          // hide (not grey) a value that has no available variant with the
          // other current picks — so a size only lists the colours it comes in
          btn.classList.toggle('is-out', !ok);
          btn.hidden = !ok;
        });
      });

      // spec rows that mirror a variant option
      Array.prototype.forEach.call(root.querySelectorAll('[data-kiaa-spec-opt]'), function (row) {
        var p = parseInt(row.getAttribute('data-kiaa-spec-opt'), 10) - 1;
        var vv = row.querySelector('[data-kiaa-spec-optval]');
        if (vv && state[p] != null) vv.textContent = state[p];
      });

      // a variant with its own image → reveal that media slide; otherwise fall
      // back to swapping the primary image's src (variant image not in the media list).
      if (v.mediaId != null && root.querySelector('[data-kiaa-slide][data-media-id="' + v.mediaId + '"]')) {
        galShow(root, v.mediaId);
      } else if (v.mediaFull) {
        var galImg = root.querySelector('[data-kiaa-gal-img]');
        if (galImg && galImg.tagName === 'IMG') { galImg.removeAttribute('srcset'); galImg.src = v.mediaFull; }
      }

      var selbar = root.querySelector('[data-kiaa-selbar]');
      if (selbar) {
        selbar.classList.toggle('bad', !available);
        var txt = selbar.querySelector('[data-kiaa-seltext]');
        if (txt) txt.innerHTML = available
          ? 'Selected: <b>' + v.title + '</b> · ready stock'
          : '<b>' + v.title + '</b> is not stocked. Pick another combination or ask us on WhatsApp.';
      }

      paint({
        mkCents: v.mkCents, w: v.w, l: v.l, breakdown: v.breakdown, hasW: v.hasW, hasL: v.hasL,
        q: q, varTitle: groups.length ? v.title : null, code: v.sku, available: available, varId: v.id
      });

      // ── custom length ────────────────────────────────────────────────
      // The piece weight is unknown for a custom length, so: reveal the inches
      // input, hide the Weight tile, and hide the WHOLE making-charge / totals
      // panel (rate, selected variant, quantity, silver note). Labour & Purity
      // tiles stay; the final amount is confirmed after the order.
      if (customWrap) customWrap.hidden = !custom;
      hide('[data-kiaa-price-panel]', custom);
      if (custom) {
        hide('[data-kiaa-ks-wt-tile]', true);
        // the mobile sticky bar mirrors the making charge — show the rate for custom
        setText('[data-kiaa-sticky-total]', '₹' + numTxt(v.l) + '/g');
        setText('[data-kiaa-sticky-calc]', '');
      }
    }

    groups.forEach(function (g) {
      var p = parseInt(g.getAttribute('data-kiaa-opt'), 10) - 1;
      Array.prototype.forEach.call(g.querySelectorAll('[data-opt-value]'), function (btn) {
        btn.addEventListener('click', function () { state[p] = btn.getAttribute('data-opt-value'); reconcile(p); render(); });
      });
    });

    if (qtyInput) {
      var step = function (d) { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d); render(); };
      var minus = root.querySelector('[data-kiaa-minus]');
      var plus = root.querySelector('[data-kiaa-plus]');
      if (minus) minus.addEventListener('click', function () { step(-1); });
      if (plus) plus.addEventListener('click', function () { step(1); });
      qtyInput.addEventListener('input', render);
    }

    // custom-length input: digits only, max 3 (e.g. "22"), clear the error state
    if (customInput) {
      customInput.addEventListener('input', function () {
        var clean = customInput.value.replace(/\D/g, '').slice(0, 3);
        if (clean !== customInput.value) customInput.value = clean;
        customInput.classList.remove('err');
        var errEl = root.querySelector('[data-kiaa-custom-error]');
        if (errEl) errEl.hidden = true;
      });
    }

    var thumbs = root.querySelector('[data-kiaa-thumbs]');
    if (thumbs) {
      Array.prototype.forEach.call(thumbs.querySelectorAll('button'), function (b) {
        b.addEventListener('click', function () { galShow(root, b.getAttribute('data-media-id')); });
      });
    }

    // Sticky buy bar: on phones/tablets it stays pinned to the bottom the whole
    // time (the merchant asked for it never to disappear); on desktop it is never
    // shown. The body flag reserves space for it and lifts the WhatsApp button.
    var sticky = root.querySelector('[data-kiaa-sticky]');
    function syncSticky() {
      if (!sticky) return;
      var mobile = window.innerWidth <= 820;
      sticky.hidden = !mobile;
      document.body.classList.toggle('kiaa-sticky-on', mobile);
    }
    if (sticky) {
      syncSticky();
      window.addEventListener('resize', syncSticky);
    }

    // Add to order — post straight to /cart/add.js, the same reliable path the
    // shoppable reels use. This bypasses Dawn's <product-form> handler (which was
    // not adding anything on this custom template). Runs in the capture phase so
    // it fires before, and cancels, any handler the <product-form> element added.
    var addForm = root.querySelector('#kiaa-add-form') || root.querySelector('form');
    var varIdInput = root.querySelector('[data-kiaa-varid]');
    function addToOrder() {
      if (!varIdInput || !varIdInput.value || varIdInput.disabled) return;
      var id = Number(varIdInput.value);
      if (!id) return;
      var qty = qtyVal();
      // custom length: require an inches value and enforce the 25-piece minimum
      var custom = isCustom();
      var props = null;
      if (custom) {
        var inches = customInput ? customInput.value.replace(/\D/g, '') : '';
        if (!inches) {
          // don't fail silently — show the error and jump to the input
          var errEl = root.querySelector('[data-kiaa-custom-error]');
          if (errEl) errEl.hidden = false;
          if (customInput) {
            customInput.classList.add('err');
            customInput.focus();
            customInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
        if (qty < CUSTOM_MOQ) { qty = CUSTOM_MOQ; if (qtyInput) qtyInput.value = CUSTOM_MOQ; }
        props = { 'Length (custom)': inches + ' inch' };
      }
      // Stamp the making rate (+ weight for standard lengths) onto the order line,
      // so they show at checkout and on the admin order page under each item.
      var selVar = variants.filter(function (x) { return x.id === id; })[0];
      if (selVar) {
        var extra = kiaaLineProps(selVar.w, selVar.l, custom ? 'custom' : selVar.title);
        if (extra) {
          if (!props) props = {};
          for (var pk in extra) { props[pk] = extra[pk]; }
        }
      }
      var label = root.querySelector('[data-kiaa-add-text]');
      var addBtn = root.querySelector('[data-kiaa-add]');
      var orig = label ? label.textContent : '';
      if (addBtn) addBtn.disabled = true;
      if (label) label.textContent = 'Adding…';
      var reset = function (txt) {
        if (label) label.textContent = txt;
        setTimeout(function () {
          if (label) label.textContent = orig || 'Add to order';
          if (addBtn) addBtn.disabled = false;
        }, 1500);
      };
      // Shared add path: refreshes the drawer or shows the "added" popup,
      // depending on the cart type picked in theme settings.
      var item = { id: id, quantity: qty };
      if (props) item.properties = props;
      var addErr = root.querySelector('[data-kiaa-add-error]');
      if (addErr) addErr.hidden = true;
      kiaaCartAdd(item, function () {
        // if the add happened inside the quick-view popup, close it
        closeQuickView();
        reset('Added ✓');
      }, function (msg) {
        reset('Try again');
        // show Shopify's reason, e.g. only so many in stock
        if (addErr && msg) { addErr.textContent = msg; addErr.hidden = false; }
      });
    }
    if (addForm) {
      addForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addToOrder();
      }, true);
    }
    // the sticky bar's own button just triggers the real one
    var stickyAdd = root.querySelector('[data-kiaa-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function () { addToOrder(); });

    render();
  }

  /* ── share a collection ────────────────────────────────────────────────
     Always use our own small menu (WhatsApp + Copy link) on every device.
     We deliberately do NOT call the Web Share API: the native OS sheet lists
     every installed app (Outlook, Gmail, Facebook, Twitter, Telegram…) and
     can't be trimmed, and KIAA wants only WhatsApp and copy-link offered. */
  function initShareButtons(scope) {
    var root = scope || document;
    var btns = root.querySelectorAll('[data-kiaa-share]');
    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.__kiaaShare) return;
      btn.__kiaaShare = true;
      btn.addEventListener('click', function (e) {
        // it lives inside the card <a>, so don't follow the card link
        e.preventDefault();
        e.stopPropagation();
        var url = btn.getAttribute('data-share-url');
        var title = btn.getAttribute('data-share-title') || document.title;
        if (!url) return;
        openShareMenu(btn, url, title);
      });
    });
  }

  function openShareMenu(btn, url, title) {
    var old = document.querySelector('.kiaa-share-menu');
    if (old) old.remove();

    var links = [
      { label: 'WhatsApp', href: 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url) }
    ];

    var menu = document.createElement('div');
    menu.className = 'kiaa-share-menu';
    links.forEach(function (l) {
      var a = document.createElement('a');
      a.href = l.href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = l.label;
      menu.appendChild(a);
    });
    var copy = document.createElement('button');
    copy.type = 'button';
    copy.textContent = 'Copy link';
    copy.addEventListener('click', function () {
      try {
        navigator.clipboard.writeText(url);
        copy.textContent = 'Link copied ✓';
      } catch (err) {
        copy.textContent = url;
      }
    });
    menu.appendChild(copy);

    document.body.appendChild(menu);
    var r = btn.getBoundingClientRect();
    menu.style.position = 'absolute';
    menu.style.top = window.scrollY + r.bottom + 6 + 'px';
    var left = window.scrollX + r.left;
    left = Math.min(left, window.scrollX + window.innerWidth - menu.offsetWidth - 12);
    menu.style.left = Math.max(8, left) + 'px';

    setTimeout(function () {
      document.addEventListener('click', function closer(ev) {
        if (!menu.contains(ev.target)) {
          menu.remove();
          document.removeEventListener('click', closer);
        }
      });
    }, 0);
  }

  /* Product page: show the floating share button once the inline one (by the
     title) scrolls up out of view — and hide it again when you scroll back. */
  function initPdpShareFloat(root) {
    var inline = root.querySelector('.pdp-share-inline');
    var float = root.querySelector('.pdp-share-float');
    if (!inline || !float || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        float.classList.toggle('show', !e.isIntersecting);
      });
    }, { rootMargin: '-90px 0px 0px 0px', threshold: 0 });
    io.observe(inline);
  }

  function boot(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kiaa-product]'), initProduct);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kiaa-slider]'), initSlider);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kiaa-rail-wrap]'), initRail);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kiaa-filters]'), initFilters);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kiaa-reels]'), initReelAdd);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kiaa-reels]'), initReelVideos);
    initCardAdds(scope === document ? document : scope);
    initCardBuy(scope === document ? document : scope);
    initShareButtons(scope === document ? document : scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kiaa-product]'), initPdpShareFloat);
    Array.prototype.forEach.call(scope.querySelectorAll('.kiaa-collection'), initCollection);
    Array.prototype.forEach.call(scope.querySelectorAll('.kiaa-collection'), initReelVideos);
    initCardCarousels(scope === document ? document : scope);
    initVideoModal();
    initCatbar();
    initStickyOffsets();
    initMobileSearch();
    initHashScroll();
  }

  // Close the cart drawer when the dark overlay (i.e. outside the panel) is clicked.
  // Dawn binds this itself, but our custom add-to-cart path swaps the #CartDrawer
  // innerHTML and so replaces the overlay node, losing Dawn's listener. A single
  // delegated listener on the document survives every re-render.
  document.addEventListener('click', function (e) {
    var overlay = e.target.closest && e.target.closest('#CartDrawer-Overlay');
    if (!overlay) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // re-init a single section when it is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });

  document.addEventListener('shopify:section:select', function () {
    refreshCartCount();
  });
})();
